var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-chat-with-qq",on:{"click":_vm.onChatClick}},[_c('img',{attrs:{"src":require('@/images/ico_consult.png'),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }